export default __webpack_public_path__ + "static/media/tennis.9a19fbf3.png";